const ProjectFields = [
    {
      id: 'title',
      label: 'Title',
      type: 'text',
      placeholder: 'Enter project title',
    },
    {
      id: 'description',
      label: 'Description',
      type: 'textarea',
      placeholder: 'Enter project description',
    },
    {
      id: 'startDate',
      label: 'Start Date',
      type: 'date',
      placeholder: 'Select start date',
    },
    {
      id: 'endDate',
      label: 'End Date',
      type: 'date',
      placeholder: 'Select end date',
    },
    {
      id: 'link',
      label: 'Link',
      type: 'text',
      placeholder: 'Enter project link',
    },
  ];
  
  export default ProjectFields;